module.exports = __webpack_public_path__ + "images/banners/page_lp_aisatei/banner_pc_dd678a08690123c24d22bdb0e5ff5839.webp";